/** Textos do módulo Férias e ausências (pacote 2). Sem travessão e sem emoji; o es usa "tú". */
const pt = {
  nome: 'Férias e ausências',
  abas: { pedidos: 'Pedidos', aprovacoes: 'Aprovações', calendario: 'Calendário', saldos: 'Saldos', tipos: 'Tipos' },
  buscaGlobal: { pedidos: 'Pedidos de ausência' },
  indicadores: { ausencias_hoje: 'Ausentes hoje' },
  acoes: {
    novoPedido: 'Novo pedido', novoTipo: 'Novo tipo', aprovar: 'Aprovar', recusar: 'Recusar', cancelarPedido: 'Cancelar pedido',
    ajustar: 'Ajustar direito', voltarAoTipo: 'Voltar ao saldo do tipo', mesAnterior: 'Mês anterior', mesSeguinte: 'Mês seguinte', folhaDoMes: 'Exportar para a folha',
  },
  campos: {
    funcionario: 'Funcionário', funcionarioAjuda: 'Vazio: o seu próprio pedido.', tipo: 'Tipo', inicio: 'Início', fim: 'Fim', dias: 'Dias', estado: 'Situação',
    observacao: 'Observação', motivo: 'Motivo', nome: 'Nome', categoria: 'Categoria', remunerada: 'Remunerada', saldoAnual: 'Saldo anual (dias)',
    saldoAnualAjuda: 'Vazio: sem limite de saldo.', exigeAprovacao: 'Exige aprovação', exigeAprovacaoAjuda: 'Sem aprovação, o pedido já nasce aprovado.',
    contagem: 'Contagem', ativo: 'Ativo', pedidos: 'Pedidos', decididoPor: 'Decidido por', ano: 'Ano', direito: 'Direito (dias)', direitoAjuda: 'Vazio: volta ao saldo anual do tipo.',
    usado: 'Usado', pendente: 'Em aberto', disponivel: 'Disponível', saldos: 'Saldos', periodos: 'Períodos', competencia: 'Competência',
  },
  estado: { pedido: 'Em aberto', aprovado: 'Aprovado', recusado: 'Recusado', cancelado: 'Cancelado', todos: 'Todos' },
  categoria: { ferias: 'Férias', atestado: 'Atestado', folga: 'Folga', licenca: 'Licença', outro: 'Outro' },
  contagem: { corridos: 'Dias corridos', uteis: 'Dias úteis (jornada do funcionário)' },
  sim: 'Sim', nao: 'Não', semLimite: 'Sem limite', ajustado: 'ajustado', remunerada: 'Remunerada', naoRemunerada: 'Não remunerada',
  diasN_one: '{{count}} dia', diasN_other: '{{count}} dias',
  periodo: '{{de}} a {{ate}}',
  vazio: {
    pedidos: 'Nenhum pedido de ausência por aqui.', aprovacoes: 'Nenhum pedido esperando decisão.', calendario: 'Ninguém ausente neste mês.',
    saldos: 'Nenhum funcionário com saldo neste ano. Os tipos com saldo anual aparecem aqui.', tipos: 'Nenhum tipo de ausência. Crie Férias, Atestado e Folga para começar.',
    folha: 'Nenhuma ausência aprovada nesta competência.',
  },
  confirmar: {
    excluirTipo: 'Excluir o tipo?', excluirTipoTexto: 'Só sai o tipo sem pedidos nem saldos; com uso, desative o tipo.',
    cancelar: 'Cancelar o pedido?', cancelarTexto: 'O pedido sai do calendário e libera o saldo.',
  },
  aviso: {
    tiposTodas: 'Os tipos valem para todas as empresas: só quem vê todas as empresas cria ou altera.',
    folha: 'Dias de ausência aprovada na competência, por funcionário e tipo. Lance na Folha os não remunerados como variável (faltas).',
    semPessoas: 'Os pedidos são do funcionário ligado ao seu usuário em Pessoas.',
  },
  recusar: { titulo: 'Recusar o pedido', ajuda: 'Diga o motivo: a pessoa vê no pedido.' },
};

const en: typeof pt = {
  nome: 'Time off',
  abas: { pedidos: 'Requests', aprovacoes: 'Approvals', calendario: 'Calendar', saldos: 'Balances', tipos: 'Types' },
  buscaGlobal: { pedidos: 'Leave requests' },
  indicadores: { ausencias_hoje: 'Away today' },
  acoes: {
    novoPedido: 'New request', novoTipo: 'New type', aprovar: 'Approve', recusar: 'Decline', cancelarPedido: 'Cancel request',
    ajustar: 'Adjust entitlement', voltarAoTipo: 'Back to the type balance', mesAnterior: 'Previous month', mesSeguinte: 'Next month', folhaDoMes: 'Export to payroll',
  },
  campos: {
    funcionario: 'Employee', funcionarioAjuda: 'Empty: your own request.', tipo: 'Type', inicio: 'Start', fim: 'End', dias: 'Days', estado: 'Status',
    observacao: 'Note', motivo: 'Reason', nome: 'Name', categoria: 'Category', remunerada: 'Paid', saldoAnual: 'Yearly balance (days)',
    saldoAnualAjuda: 'Empty: no balance limit.', exigeAprovacao: 'Requires approval', exigeAprovacaoAjuda: 'Without approval, the request is approved right away.',
    contagem: 'Count', ativo: 'Active', pedidos: 'Requests', decididoPor: 'Decided by', ano: 'Year', direito: 'Entitlement (days)', direitoAjuda: "Empty: back to the type's yearly balance.",
    usado: 'Used', pendente: 'Open', disponivel: 'Available', saldos: 'Balances', periodos: 'Periods', competencia: 'Period',
  },
  estado: { pedido: 'Open', aprovado: 'Approved', recusado: 'Declined', cancelado: 'Canceled', todos: 'All' },
  categoria: { ferias: 'Vacation', atestado: 'Sick note', folga: 'Day off', licenca: 'Leave', outro: 'Other' },
  contagem: { corridos: 'Calendar days', uteis: "Working days (employee's schedule)" },
  sim: 'Yes', nao: 'No', semLimite: 'No limit', ajustado: 'adjusted', remunerada: 'Paid', naoRemunerada: 'Unpaid',
  diasN_one: '{{count}} day', diasN_other: '{{count}} days',
  periodo: '{{de}} to {{ate}}',
  vazio: {
    pedidos: 'No time off requests here.', aprovacoes: 'No requests waiting for a decision.', calendario: 'Nobody away this month.',
    saldos: 'No employee with a balance this year. Types with a yearly balance show up here.', tipos: 'No time off types. Create Vacation, Sick note and Day off to start.',
    folha: 'No approved time off in this period.',
  },
  confirmar: {
    excluirTipo: 'Delete the type?', excluirTipoTexto: 'Only a type without requests or balances is deleted; if in use, deactivate it.',
    cancelar: 'Cancel the request?', cancelarTexto: 'The request leaves the calendar and frees the balance.',
  },
  aviso: {
    tiposTodas: 'Types apply to all companies: only someone who sees all companies creates or changes them.',
    folha: 'Approved time off days in the period, by employee and type. Post the unpaid ones in Payroll as a variable (absences).',
    semPessoas: 'Requests belong to the employee linked to your user in People.',
  },
  recusar: { titulo: 'Decline the request', ajuda: 'Say why: the person sees it on the request.' },
};

const es: typeof pt = {
  nome: 'Vacaciones y ausencias',
  abas: { pedidos: 'Solicitudes', aprovacoes: 'Aprobaciones', calendario: 'Calendario', saldos: 'Saldos', tipos: 'Tipos' },
  buscaGlobal: { pedidos: 'Solicitudes de ausencia' },
  indicadores: { ausencias_hoje: 'Ausentes hoy' },
  acoes: {
    novoPedido: 'Nueva solicitud', novoTipo: 'Nuevo tipo', aprovar: 'Aprobar', recusar: 'Rechazar', cancelarPedido: 'Cancelar solicitud',
    ajustar: 'Ajustar derecho', voltarAoTipo: 'Volver al saldo del tipo', mesAnterior: 'Mes anterior', mesSeguinte: 'Mes siguiente', folhaDoMes: 'Exportar a la nómina',
  },
  campos: {
    funcionario: 'Empleado', funcionarioAjuda: 'Vacío: tu propia solicitud.', tipo: 'Tipo', inicio: 'Inicio', fim: 'Fin', dias: 'Días', estado: 'Estado',
    observacao: 'Observación', motivo: 'Motivo', nome: 'Nombre', categoria: 'Categoría', remunerada: 'Remunerada', saldoAnual: 'Saldo anual (días)',
    saldoAnualAjuda: 'Vacío: sin límite de saldo.', exigeAprovacao: 'Requiere aprobación', exigeAprovacaoAjuda: 'Sin aprobación, la solicitud ya nace aprobada.',
    contagem: 'Conteo', ativo: 'Activo', pedidos: 'Solicitudes', decididoPor: 'Decidido por', ano: 'Año', direito: 'Derecho (días)', direitoAjuda: 'Vacío: vuelve al saldo anual del tipo.',
    usado: 'Usado', pendente: 'Abierto', disponivel: 'Disponible', saldos: 'Saldos', periodos: 'Períodos', competencia: 'Período',
  },
  estado: { pedido: 'Abierta', aprovado: 'Aprobada', recusado: 'Rechazada', cancelado: 'Cancelada', todos: 'Todas' },
  categoria: { ferias: 'Vacaciones', atestado: 'Certificado médico', folga: 'Día libre', licenca: 'Licencia', outro: 'Otro' },
  contagem: { corridos: 'Días corridos', uteis: 'Días hábiles (jornada del empleado)' },
  sim: 'Sí', nao: 'No', semLimite: 'Sin límite', ajustado: 'ajustado', remunerada: 'Remunerada', naoRemunerada: 'No remunerada',
  diasN_one: '{{count}} día', diasN_other: '{{count}} días',
  periodo: '{{de}} a {{ate}}',
  vazio: {
    pedidos: 'Ninguna solicitud de ausencia por aquí.', aprovacoes: 'Ninguna solicitud esperando decisión.', calendario: 'Nadie ausente este mes.',
    saldos: 'Ningún empleado con saldo este año. Los tipos con saldo anual aparecen aquí.', tipos: 'Ningún tipo de ausencia. Crea Vacaciones, Certificado médico y Día libre para empezar.',
    folha: 'Ninguna ausencia aprobada en este período.',
  },
  confirmar: {
    excluirTipo: '¿Eliminar el tipo?', excluirTipoTexto: 'Solo sale el tipo sin solicitudes ni saldos; con uso, desactívalo.',
    cancelar: '¿Cancelar la solicitud?', cancelarTexto: 'La solicitud sale del calendario y libera el saldo.',
  },
  aviso: {
    tiposTodas: 'Los tipos valen para todas las empresas: solo quien ve todas las empresas los crea o cambia.',
    folha: 'Días de ausencia aprobada en el período, por empleado y tipo. Registra en Nómina los no remunerados como variable (faltas).',
    semPessoas: 'Las solicitudes son del empleado vinculado a tu usuario en Personas.',
  },
  recusar: { titulo: 'Rechazar la solicitud', ajuda: 'Di el motivo: la persona lo ve en la solicitud.' },
};

export const i18n = { pt, en, es };
